import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, fmt } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Reveal } from "../components/Reveal";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState("orders");
  const [orders, setOrders] = useState([]);
  const [wish, setWish] = useState([]);

  useEffect(() => {
    if (!loading && !user) nav("/login");
  }, [loading, user, nav]);

  useEffect(() => {
    if (!user) return;
    api.get("/orders/me").then((r) => setOrders(r.data)).catch(() => {});
    api.get("/wishlist").then((r) => setWish(r.data)).catch(() => {});
  }, [user, tab]);

  if (loading || !user) return <div className="pt-40 text-center caption text-sm">Loading…</div>;

  return (
    <div data-testid="account-page" className="pt-16">
      <div className="px-6 md:px-10 lg:px-20 pt-16 pb-28">
        <Reveal>
          <div className="flex items-start justify-between">
            <div>
              <p className="util-link text-[11px] caption mb-3">My Account</p>
              <h1 className="font-display text-5xl sm:text-6xl uppercase">{user.name || user.email}</h1>
              <p className="caption text-[12px] mt-3">{user.email}</p>
            </div>
            <button data-testid="account-logout" onClick={async () => { await logout(); nav("/"); }} className="util-link text-[11px] link-hover">Log out</button>
          </div>
        </Reveal>

        <div className="flex gap-6 mt-12 mb-10 border-b border-border pb-4">
          {[["orders", "My Orders"], ["wishlist", "Wishlist"]].map(([k, l]) => (
            <button key={k} data-testid={`account-tab-${k}`} onClick={() => setTab(k)}
              className={`product-title text-[13px] link-hover pb-1 ${tab === k ? "border-b border-black" : "text-graphite"}`}>{l}</button>
          ))}
        </div>

        {tab === "orders" && (
          <div data-testid="account-orders" className="space-y-4">
            {orders.length === 0 && (
              <div className="py-16 text-center">
                <p className="caption text-sm mb-6">You have no orders yet.</p>
                <Link to="/shop" className="bg-black text-white px-8 py-3.5 product-title text-[12px] link-hover">Start Shopping</Link>
              </div>
            )}
            {orders.map((o) => (
              <div key={o.id} className="border border-border p-6">
                <div className="flex justify-between flex-wrap gap-2">
                  <div>
                    <p className="product-title text-[12px]">#{o.id.slice(0, 8).toUpperCase()}</p>
                    <p className="text-xs caption">{new Date(o.created_at).toLocaleString()}</p>
                  </div>
                  <div className="text-right">
                    <span className="util-link text-[10px] border border-black px-3 py-1">{o.payment_status}</span>
                    <p className="text-lg mt-1">{fmt(o.subtotal)}</p>
                  </div>
                </div>
                <p className="text-sm caption mt-3">{o.items.map((i) => `${i.name} ×${i.quantity}`).join(", ")}</p>
              </div>
            ))}
          </div>
        )}

        {tab === "wishlist" && (
          <div data-testid="account-wishlist">
            {wish.length === 0 ? (
              <p className="caption text-sm py-16 text-center">Your wishlist is empty. Tap the heart on any product to save it.</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {wish.map((p) => <ProductCard key={p.id} product={p} />)}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
